module.exports = __webpack_public_path__ + "static/media/litter_intelligence_logo.a57708a7.svg";